/**
 * Sync codes for multi-Check working papers.
 * See docs/wp-multi-check-components-analysis.md §4.4.1
 */
export const WP_SPECIAL_SYNC_CODES_BY_COMPONENT: Record<string, string[]> = {
    PropertyPlantEquipment: ['BS-NCA-PPE', 'PL-AE-DEP', 'PL-OI-GOD', 'PL-AE-LOD'],
    TaxiLicensesWp: ['BS-NCA-ITL', 'PL-AE-DEP', 'PL-OI-GOD', 'PL-AE-LOD'],
    IntangibleAssets: ['BS-NCA-IA', 'PL-AE-AIA', 'PL-OI-GOD', 'PL-AE-LOD'],
    BankLoan: ['BS-CL-BLS', 'BS-NCL-BLS', 'PL-FC-LI'],
    TaxWp: ['BS-CA-TAXR', 'BS-CL-TAXP', 'PL-TAX'],
    SalariesWageWp: ['PL-AE-SAL', 'PL-AE-WAG', 'PL-AE-MPF'],
    DirectorSalaryWp: ['PL-AE-DR', 'PL-AE-DQ', 'PL-AE-MPF'],
    VehicleLoan: ['BS-CL-OFL', 'BS-NCL-OFL', 'PL-FC-LI'],
    DueFromToDirectorsWp: ['BS-CA-DIR', 'BS-CL-DTD'],
    InventoriesWp: ['BS-CA-INV', 'PL-COT-CI', 'PL-COT-OI'],
    GainLossExchangeWp: ['PL-OI-EXG', 'PL-AE-EXL'],
    GainLossDisposalWp: ['PL-OI-GOD', 'PL-AE-LOD'],
    RentalExpenseWp: ['PL-AE-REN'],
    MpfSummaryWp: ['PL-AE-MPF', 'PL-AE-SAL', 'PL-AE-WAG', 'PL-AE-DR', 'PL-AE-DQ'],
    InterestSummaryWp: ['PL-FC-LI', 'BS-CL-BLS', 'BS-NCL-BLS', 'BS-CL-OFL', 'BS-NCL-OFL'],
};

export const WP_SPECIAL_SYNC_CODES_BY_SAVE_CODE: Record<string, string[]> = {
    'BS-NCA-PPE': ['BS-NCA-PPE', 'PL-AE-DEP', 'PL-OI-GOD', 'PL-AE-LOD'],
    'PL-AE-DEP': ['BS-NCA-PPE', 'PL-AE-DEP'],
    'BS-NCA-ITL': ['BS-NCA-ITL', 'PL-AE-DEP', 'PL-OI-GOD', 'PL-AE-LOD'],
    'BS-NCA-IA': ['BS-NCA-IA', 'PL-AE-AIA', 'PL-OI-GOD', 'PL-AE-LOD'],
    'PL-AE-AIA': ['BS-NCA-IA', 'PL-AE-AIA'],
    'BS-NCA-ISUB': ['BS-NCA-ISUB', 'PL-OI-GOD', 'PL-AE-LOD'],
    'BS-NCA-IASS': ['BS-NCA-IASS', 'PL-OI-GOD', 'PL-AE-LOD'],
    'BS-CA-IOT': ['BS-CA-IOT', 'PL-OI-GOD', 'PL-AE-LOD'],
    'BS-CL-BLS': ['BS-CL-BLS', 'BS-NCL-BLS', 'PL-FC-LI'],
    'BS-NCL-BLS': ['BS-CL-BLS', 'BS-NCL-BLS', 'PL-FC-LI'],
    'PL-FC-LI': ['PL-FC-LI', 'BS-CL-BLS', 'BS-NCL-BLS', 'BS-CL-OFL', 'BS-NCL-OFL'],
    'PL-TAX': ['BS-CA-TAXR', 'BS-CL-TAXP', 'PL-TAX'],
    'BS-CA-TAXR': ['BS-CA-TAXR', 'BS-CL-TAXP', 'PL-TAX'],
    'BS-CL-TAXP': ['BS-CA-TAXR', 'BS-CL-TAXP', 'PL-TAX'],
    'PL-AE-SAL': ['PL-AE-SAL', 'PL-AE-WAG', 'PL-AE-MPF'],
    'PL-AE-WAG': ['PL-AE-SAL', 'PL-AE-WAG', 'PL-AE-MPF'],
    'PL-AE-DR': ['PL-AE-DR', 'PL-AE-DQ', 'PL-AE-MPF'],
    'PL-AE-DQ': ['PL-AE-DR', 'PL-AE-DQ', 'PL-AE-MPF'],
    'PL-AE-MPF': ['PL-AE-MPF', 'PL-AE-SAL', 'PL-AE-WAG', 'PL-AE-DR', 'PL-AE-DQ'],
    'BS-CL-OFL': ['BS-CL-OFL', 'BS-NCL-OFL', 'PL-FC-LI'],
    'BS-NCL-OFL': ['BS-CL-OFL', 'BS-NCL-OFL', 'PL-FC-LI'],
    'BS-CA-DIR': ['BS-CA-DIR', 'BS-CL-DTD'],
    'BS-CL-DTD': ['BS-CA-DIR', 'BS-CL-DTD'],
    'BS-CA-INV': ['BS-CA-INV', 'PL-COT-CI', 'PL-COT-OI'],
    'PL-COT-CI': ['BS-CA-INV', 'PL-COT-CI', 'PL-COT-OI'],
    'PL-COT-OI': ['BS-CA-INV', 'PL-COT-CI', 'PL-COT-OI'],
    'PL-OI-EXG': ['PL-OI-EXG', 'PL-AE-EXL', 'PL-TAX'],
    'PL-AE-EXL': ['PL-OI-EXG', 'PL-AE-EXL', 'PL-TAX'],
    'PL-OI-GOD': ['PL-OI-GOD', 'PL-AE-LOD'],
    'PL-AE-LOD': ['PL-OI-GOD', 'PL-AE-LOD'],
    'PL-AE-REN': ['PL-AE-REN', 'BS-CA-DPP'],
};

/**
 * Alias codes that share WP data with a canonical code on the backend.
 * When fetching WP data, use the canonical code in the API request.
 */
export const WP_FETCH_CODE_ALIAS: Record<string, string> = {
    'BS-CL-DTD': 'BS-CA-DIR',
    'PL-AE-EXL': 'PL-OI-EXG',
    'PL-AE-LOD': 'PL-OI-GOD',
    'PL-AE-AIA': 'BS-NCA-IA',
    'BS-CA-TAXR': 'PL-TAX',
    'BS-CL-TAXP': 'PL-TAX',
    // Bank / Vehicle loan：non-current 与 current 共享同一份 WP，GET 统一用 current code
    'BS-NCL-BLS': 'BS-CL-BLS',
    'BS-NCL-OFL': 'BS-CL-OFL',
};

/** Resolve UI/FS code to the code used for working-paper GET requests. */
export function resolveWpFetchCode(code: string): string {
    const upper = String(code || '').trim().toUpperCase();
    return WP_FETCH_CODE_ALIAS[upper] ?? upper;
}

export function resolveWpSpecialSyncCodes(saveCode: string, componentName?: string): string[] {
    const upper = String(saveCode || '').trim().toUpperCase();
    if (upper && WP_SPECIAL_SYNC_CODES_BY_SAVE_CODE[upper]) {
        return WP_SPECIAL_SYNC_CODES_BY_SAVE_CODE[upper];
    }
    if (componentName && WP_SPECIAL_SYNC_CODES_BY_COMPONENT[componentName]) {
        return WP_SPECIAL_SYNC_CODES_BY_COMPONENT[componentName];
    }
    return upper ? [upper] : [];
}
